"use strict";
import bootstrapper from "lib/loader";

// App style
require(`../style/index.scss`);

/**
 * Init React App.
 *
 * @version 1.0 FINAL - rev. 13.8.2018
 */
bootstrapper((resolve) => (
    require(['components/Router'], (...imported) => {
        resolve(imported);
    })
), env.API_URL, env.SENTRY);



// WEBPACK FOOTER //
// ./src/app.js